import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { VariablePayService } from '../services/variable-pay/variable-pay.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { FlashService } from '../flash/flash.service';

@Component({
  selector: 'app-variable-pay',
  templateUrl: './variable-pay.component.html',
  styleUrls: ['./variable-pay.component.css']
})
export class VariablePayComponent implements OnInit, OnDestroy {
  employeesList = [];
  totalCount: number;
  accountsList = [];
  assessmentYearsList = [];
  unSub: Subject<void> = new Subject<void>();
  selectedFile: File = null;
  uploadFile = new FormControl(null, Validators.required);
  fileRequiredMsg = '';
  fileTypeError = '';
  accountId = '';
  assessmentYear = '';
  variableAmount = '';
  accountError = false;
  yearError = false;
  amountError = false;
  variable_pay = {};
  pageNo = 1;
  perPage = 10;
  filterAccountId = '';
  searchAccount = '';
  filterAssessmentYear = '';
  employeeListParams = {};
  showModalBox: boolean = false;
  deleteshowModalBox: boolean = false;
  public editUserInfo;
  public editVaiablePay;
  public deleteId;
  public errorMsgAmount:boolean = false;
  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  constructor(
    private varPayService: VariablePayService,
    private flashService: FlashService,
  ) { }

  ngOnInit() {
    this.getAccountsList();
    this.getAssessmentYearsList();
  }

  ngOnDestroy() {
    this.unSub.next();
    this.unSub.complete();
  }

  /**
   * @description
   * Method to get employees list
   */
  getEmployeesList(isFromPagination = false) {
    this.employeeListParams = {};
    if (!isFromPagination) { this.pageNo = 1; }
    this.employeeListParams['page_no'] = this.pageNo;
    this.employeeListParams['per_page'] = this.perPage;
    (this.filterAssessmentYear) ? this.employeeListParams['assessment_year'] = this.filterAssessmentYear : null;
    (this.filterAccountId) ? this.employeeListParams['account_id'] = this.filterAccountId : null;
    (this.searchAccount) ? this.employeeListParams['search'] = this.searchAccount : null;
    this.varPayService.getEmployeesList(this.employeeListParams).pipe(takeUntil(this.unSub)).subscribe(
      (res) => {
        if (res.body['success']) {
          this.employeesList = res.body['result'];
          this.totalCount = res.body['count'];
          this.calculateDays(this.employeesList);
        }
      }
    );
  }

  setTime(obj: Date) {
    obj.setHours(23, 59, 59);
    return obj;
  }

  calculateDays(employeesList) {
    for (let employee of employeesList) {
      let date = new Date(employee.created_at);
      date.setDate( date.getDate() + 90 );
      this.setTime(date);
      if ( new Date() <= date ) {
        employee.edit = true;
      } else {
        employee.edit = false;
      }
    }
  }

  /**
   * @description
   * Method to get accounts list
   */
  getAccountsList() {
    this.varPayService.getAccountsList().pipe(takeUntil(this.unSub)).subscribe(
      (res) => {
        if (res.body['success']) {
          this.accountsList = res.body['result'].accounts;
        }
      }
    );
  }

  /**
   * @description
   * Method to get assessment years list
   */
  getAssessmentYearsList() {
    this.varPayService.getAssessmentYearsList().pipe(takeUntil(this.unSub)).subscribe(
      (res) => {
        if (res.body['success']) {
          this.assessmentYearsList = res.body['result'];
          for (let year of this.assessmentYearsList) {
            if (year.is_current_year) {
              this.filterAssessmentYear = year.assessment_year;
              this.getEmployeesList();
            }
          }
        }
      }
    );
  }

  /**
   * @description
   * Event handler for file input
   */
  fileUploaded($event) {
    if (!$event.target.files || $event.target.files.length <= 0) {
      return false;
    }
    const file = $event.target.files[0];
    if (file.type === 'text/csv') {
      this.selectedFile = file;
      this.fileRequiredMsg = '';
      this.fileTypeError = '';
    } else {
      this.fileRequiredMsg = '';
      this.fileTypeError = 'File format wrong';
    }
  }

  /**
   * @description
   * Method to upload csv file
   */
  bulkUploadVariablePay() {
    if (this.uploadFile.hasError('required')) {
      this.fileRequiredMsg = 'File required';
      return;
    }
    if (this.selectedFile && !this.fileTypeError) {
      this.varPayService.bulkUploadVariablePay(this.selectedFile).pipe(takeUntil(this.unSub)).subscribe(
        res => {
          this.closeCreateModal.nativeElement.click();
          if (res.body['success']) {
            this.flashService.show(res.body['message'], 'alert-success');
            this.getEmployeesList();
          }
          else {
            this.flashService.show(res.body['message'], 'alert-danger');
          }
        }
      );
    }
  }

  /**
   * @description
   * Method to create variable pay for individual
   */
  createVariablePay() {
    this.accountError = (!this.accountId) ? true : false;
    this.yearError = (!this.assessmentYear) ? true : false;
    this.amountError = (!this.variableAmount) ? true : false;
    if (!this.assessmentYear || !this.variableAmount || !this.accountId) {
      return;
    }
    this.variable_pay['assessment_year'] = this.assessmentYear;
    this.variable_pay['yearly_amount'] = this.variableAmount;
    this.variable_pay['account_id'] = Number(this.accountId);
    this.varPayService.createVariablePay(this.variable_pay).pipe(takeUntil(this.unSub)).subscribe(
      res => {
        this.closeCreateModal.nativeElement.click();
        if (res.body['success']) {
          this.flashService.show(res.body['message'], 'alert-success');
          this.getEmployeesList();
        }
        else {
          this.flashService.show(res.body['message'], 'alert-danger');
        }
      }
    );
  }

  /**
   * @description
   * call back event from page change
   * @param value
   */
  pageEvent(value) {
    this.pageNo = value;
    this.getEmployeesList(true);
  }

  /**
   * @description
   * Method to reset the create modal
   */
  resetCreateModal() {
    this.uploadFile.setValue(null);
    this.selectedFile = null;
    this.fileRequiredMsg = '';
    this.fileTypeError = '';
    this.accountId = '';
    this.assessmentYear = '';
    this.variableAmount = '';
    this.accountError = false;
    this.yearError = false;
    this.amountError = false;
  }

  editEmployeePay(userId) {
    this.errorMsgAmount = false;
    if (userId) {
      this.editUserInfo = userId;
    }
    if (this.editUserInfo.yearly_amount) {
      this.editVaiablePay = this.editUserInfo.yearly_amount;
    }
    this.showModalBox = true;
  }

  /**
   * @description
   * Method to edit employee variable pay
   */
  updateEdit() {
    if (this.editVaiablePay) {
      const dataCollection = {'yearly_amount' : this.editVaiablePay};
      this.varPayService.getpostPayList(dataCollection, this.editUserInfo.id).pipe(takeUntil(this.unSub)).subscribe(
        (res) => {
            if (res.body['success']) {
              this.showModalBox = false;
              this.flashService.show(res.body['message'], 'alert-success');
              this.closeModal();
              this.getEmployeesList();
            }
            else {
              this.showModalBox = false;
              this.closeModal();
              this.flashService.show(res.body['message'], 'alert-danger');
            }
        }
      );
    }else {
      this.errorMsgAmount = true;
    }
  }

    private closeModal(): void {
      this.closeBtn.nativeElement.click();
    }

    deleteIdSet(id) {
      if (id) {
        this.deleteId = id;
        this.deleteshowModalBox = true;
      }
    }

    /**
   * @description
   * Method to delete employee variable pay
   */
    deleteEmployeePay() {
      if (this.deleteId) {
        this.varPayService.deletePayList(this.deleteId).pipe(takeUntil(this.unSub)).subscribe(
          (res) => {
              if (res.body['success']) {
                this.deleteshowModalBox = false;
                this.flashService.show(res.body['message'], 'alert-success');
                this.getEmployeesList();
              }
              else {
                this.deleteshowModalBox = false;
                this.flashService.show(res.body['message'], 'alert-danger');
              }
          }
        );
      }

    }

    isNumber(evt) {
      const theEvent = evt || window.event;
      let key = theEvent.keyCode || theEvent.which;
      // @ts-ignore
      key = String.fromCharCode(key);
      // tslint:disable-next-line:triple-equals
      if (key.length == 0) { return; }
      const regex = /^[0-9.,\b]+$/;
      if (!regex.test(key)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) { theEvent.preventDefault(); }
      }
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/variable-pay/variable-pay.component.ts